import React from 'react';
import { useQuery } from '@apollo/client/react';
import { InfoField } from '@components-clean/core/info-field';
import Loading from '@components-clean/core/loading/loading';
import { CM2Dataset } from '@interfaces/central-monitoring';
import { ControlsHubChart } from '@pages-clean/central-monitoring/controls-hub/sections/chart-view/controls-hub-chart';
import { useTranslation } from '@hooks/index';
import { GET_CONTROLS_HUB_CONFIG_PANELS } from '@queries/central-monitoring';
import {
    getControlsHubConfigPanelsForStudy,
    getControlsHubConfigPanelsForStudyVariables,
} from '@queries/generated/central-monitoring.generated';

type Props = {
    studyRef: string;
    dataset: CM2Dataset;
};

export const ChartsView = ({ studyRef, dataset }: Props) => {
    const { data: controlsHubConfigPanels, loading: isLoading } = useQuery<
        getControlsHubConfigPanelsForStudy,
        getControlsHubConfigPanelsForStudyVariables
    >(GET_CONTROLS_HUB_CONFIG_PANELS, {
        variables: { studyId: studyRef, timestamp: dataset.created },
    });
    const { t } = useTranslation();
    if (isLoading) return <Loading />;

    const panels = controlsHubConfigPanels?.getControlsHubConfigPanelsForStudy?.panels;
    if (!panels) {
        return (
            <div className="no-panel ">
                <InfoField message={t('cm:controlsHub.panel.noPanel')} type="Info" layout="center" />
            </div>
        );
    }
    return (
        <div className="chart-view k-d-grid k-gap-2">
            {panels?.map((panel) => {
                return (
                    <ControlsHubChart
                        studyRef={studyRef}
                        dataset={dataset}
                        panelRef={panel?.panelRef}
                        dataViewRef={panel?.dataViewRef}
                    />
                );
            })}
        </div>
    );
};
